import { render, staticRenderFns } from "./tableview.vue?vue&type=template&id=25ba9017&"
import script from "./tableview.vue?vue&type=script&lang=js&"
export * from "./tableview.vue?vue&type=script&lang=js&"
import style0 from "./tableview.vue?vue&type=style&index=0&id=25ba9017&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports